"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonUtils = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const common_1 = require("../error/common");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
class JSONUtils {
    parseJSON(content) {
        try {
            const obj = JSON.parse(content);
            return teamsfx_api_1.ok(obj);
        }
        catch (e) {
            return teamsfx_api_1.err(new common_1.JSONSyntaxError(content, e));
        }
    }
    async readJSONFile(filePath) {
        var _a;
        try {
            const res = await fs_extra_1.default.readJSON(filePath);
            return teamsfx_api_1.ok(res);
        }
        catch (e) {
            if (e.name === "SyntaxError") {
                const error = new common_1.JSONSyntaxError(filePath, e);
                return teamsfx_api_1.err(error);
            }
            else if ((_a = e.message) === null || _a === void 0 ? void 0 : _a.includes("no such file or directory")) {
                return teamsfx_api_1.err(new common_1.FileNotFoundError("common", filePath));
            }
            return teamsfx_api_1.err(new common_1.ReadFileError(e, "common"));
        }
    }
    readJSONFileSync(filePath) {
        var _a;
        try {
            const res = fs_extra_1.default.readJSONSync(filePath);
            return teamsfx_api_1.ok(res);
        }
        catch (e) {
            if (e.name === "SyntaxError") {
                const error = new common_1.JSONSyntaxError(filePath, e);
                return teamsfx_api_1.err(error);
            }
            else if ((_a = e.message) === null || _a === void 0 ? void 0 : _a.includes("no such file or directory")) {
                return teamsfx_api_1.err(new common_1.FileNotFoundError("common", filePath));
            }
            return teamsfx_api_1.err(new common_1.ReadFileError(e, "common"));
        }
    }
}
exports.jsonUtils = new JSONUtils();
//# sourceMappingURL=jsonUtils.js.map